import React from 'react';
import { BriefcaseIcon, GraduationCapIcon, LayoutDashboardIcon, PackageIcon, StarIcon, WalletIcon } from 'lucide-react';
import { OperatorShell } from './OperatorShell';
import type { NavGroup } from './OperatorShell';
import { Badge } from '../ui/Badge';
import { providerEarnings, providerProfile } from '../../data/provider';
import { naira } from '../../utils/format';
const GROUPS: NavGroup[] = [{
  label: 'Work',
  items: [{
    to: '/provider',
    label: 'Needs you today',
    icon: LayoutDashboardIcon,
    end: true
  }, {
    to: '/provider/orders',
    label: 'Orders and escrow',
    icon: BriefcaseIcon
  }, {
    to: '/provider/academic-services',
    label: 'Academic services',
    icon: GraduationCapIcon
  }]
}, {
  label: 'Your practice',
  items: [{
    to: '/provider/services',
    label: 'Services and packages',
    icon: PackageIcon
  }, {
    to: '/provider/earnings',
    label: 'Earnings and payouts',
    icon: WalletIcon
  }, {
    to: '/provider/reputation',
    label: 'Reputation',
    icon: StarIcon
  }]
}];
export function ProviderShell() {
  return <OperatorShell consoleKey="provider" consoleName="Provider console" scopeLine={`@${providerProfile.handle} · ${providerProfile.category}`} groups={GROUPS} summary={<div data-id="element-5291" data-mp="x4jp3c9qxyf1">
          <p className="text-caption text-ink-muted" data-id="element-5292" data-mp="x41iblpgk1sv">Withdrawable earnings</p>
          <p className="cz-num mt-1 text-h4 font-semibold text-ink" data-id="element-5293" data-mp="j5bku4yq803z">
            {naira(providerEarnings.withdrawableNaira)}
          </p>
          <Badge tone="warn" className="mt-2" data-id="element-5294" data-mp="o4wk6ght6ah8">
            Payouts gated
          </Badge>
        </div>} data-id="element-5290" data-mp="16ucz48u8q5h6" />;
}